import Vue from 'vue';
import {
  getReservationCalendarInfo
} from '../../../services/personnelService/reservationService';
 // initial state
 // state 必為模組區域變數，取時需 store.state.auth.user
 // 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
 // 區域使用時值需加上 name
const state = {
  reservationCalendarInfo: []
};

// getters
const getters = {};

 // actions
const actions = {
  // 取得預約列表
  async getReservationCalendarInfoHandler({ commit }, formData) {
    const data = await getReservationCalendarInfo(formData);
    commit('setReservationCalendarInfo', data);
  }
};

// mutations
const mutations = {
  setReservationCalendarInfo(state, data) {
    Vue.set(state, 'reservationCalendarInfo', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
